import { IconCrown } from '../../base/icons';
import {
    PARTICIPANT_ROLE,
    getLocalParticipant,
    getParticipantById,
    isParticipantModerator
} from '../../base/participants';
import { AbstractButton, type AbstractButtonProps } from '../../base/toolbox/components';

export type Props = AbstractButtonProps & {

    /**
     * The redux {@code dispatch} function.
     */
    dispatch: Function,

    config: any,

    /**
     * The ID of the participant for whom to grant moderator status.
     */
    participantID: string,

    totalModerators: any,

    moderators_allowed: any,

    /**
     * Jwt of the conference.
     */
    jwt: ?String,

    participant: any,

    /**
     * Target PArticipant moderator.
     */
    isTargetParticipantModerator: ?boolean,

    /**
     * The function to be used to translate i18n labels.
     */
    t: Function
};

/**
 * An abstract remote video menu button which kicks the remote participant.
 */
export default class AbstractGrantModeratorButton extends AbstractButton<Props, *> {
    accessibilityLabel = 'toolbar.accessibilityLabel.grantModerator';
    icon = IconCrown;

    label = this.props.isTargetParticipantModerator ? 'dialog.revokeModerationTitle' : 'videothumbnail.grantModerator';
}

/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @param {Object} ownProps - Properties of component.
 * @private
 * @returns {{
 *     visible: boolean
 * }}
 */
export function _mapStateToProps(state: Object, ownProps: Props) {
    const { participantID } = ownProps;
    const jwt = state['features/base/jwt']?.jwt;

    const localParticipant = getLocalParticipant(state);
    const targetParticipant = getParticipantById(state, participantID);
    const participants = state['features/base/participants'];
    const totalModerators = participants.filter(it => it.role === 'moderator' && !it?.isFakeParticipant);
    const moderators_allowed = state['features/base/mtApi']?.pregData?.moderators_allowed;
    const config = state['features/base/config'];

    return {
        visible: Boolean(localParticipant?.role === PARTICIPANT_ROLE.MODERATOR),
        isTargetParticipantModerator: isParticipantModerator(targetParticipant),
        jwt,
        participant: targetParticipant,
        totalModerators,
        moderators_allowed,
        config
    };
}
